function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var HudLayer = require('../hud-layer');
var DeckTemplate = require('./deck.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var DeckOverlay = /*#__PURE__*/function () {
  function DeckOverlay(app, mod) {
    _classCallCheck(this, DeckOverlay);
    this.app = app;
    this.mod = mod;
    this.visible = false;
    this.overlay = new SaitoOverlay(app, mod, false, true, true);
  }
  return _createClass(DeckOverlay, [{
    key: "hide",
    value: function hide() {
      this.overlay.hide();
    }
  }, {
    key: "pullHudOverOverlay",
    value: function pullHudOverOverlay() {
      HudLayer.pullHudOverOverlay.call(this);
    }
  }, {
    key: "pushHudUnderOverlay",
    value: function pushHudUnderOverlay() {
      HudLayer.pushHudUnderOverlay.call(this);
    }
  }, {
    key: "render",
    value: function render() {
      var deck = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var cards = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var his_self = this.mod;
      this.overlay.show(DeckTemplate());
      if (cards) {
        if (cards.length > 0) {
          for (var i = 0; i < cards.length; i++) {
            his_self.app.browser.addElementToSelector("<div id=\"".concat(cards[i], "\" class=\"card ").concat(cards[i], "\"><img src=\"/his/img/cards/HIS-").concat(cards[i], ".svg\" /></div>"), '.deck-overlay');
          }
          return;
        }
      }
      if (deck == 'papacy') {
        var added = 0;
        if (!his_self.game.deck[0].discards['005']) {
          added++;
          his_self.app.browser.addElementToSelector("<div id=\"005\" class=\"card 005\"><img src=\"/his/img/cards/HIS-005.svg\" /></div>", '.deck-overlay');
        }
        if (!his_self.game.deck[0].discards['006']) {
          added++;
          his_self.app.browser.addElementToSelector("<div id=\"006\" class=\"card 006\"><img src=\"/his/img/cards/HIS-006.svg\" /></div>", '.deck-overlay');
        }
        for (var _i = 0; _i < his_self.game.state.cards_left['papacy'] - added; _i++) {
          his_self.app.browser.addElementToSelector("<div id=\"cardback\" class=\"card cardback\"><img src=\"/his/img/cards/cardback.svg\" /></div>", '.deck-overlay');
        }
      }
      if (deck == 'protestant') {
        var _added = 0;
        if (!his_self.game.deck[0].discards['007']) {
          _added++;
          his_self.app.browser.addElementToSelector("<div id=\"007\" class=\"card 007\"><img src=\"/his/img/cards/HIS-007.svg\" /></div>", '.deck-overlay');
        }
        for (var _i2 = 0; _i2 < his_self.game.state.cards_left['protestant'] - _added; _i2++) {
          his_self.app.browser.addElementToSelector("<div id=\"cardback\" class=\"card cardback\"><img src=\"/his/img/cards/cardback.svg\" /></div>", '.deck-overlay');
        }
      }
      if (deck == 'england') {
        var _added2 = 0;
        if (!his_self.game.deck[0].discards['003']) {
          _added2++;
          his_self.app.browser.addElementToSelector("<div id=\"003\" class=\"card 003\"><img src=\"/his/img/cards/HIS-003.svg\" /></div>", '.deck-overlay');
        }
        for (var _i3 = 0; _i3 < his_self.game.state.cards_left['england'] - _added2; _i3++) {
          his_self.app.browser.addElementToSelector("<div id=\"cardback\" class=\"card cardback\"><img src=\"/his/img/cards/cardback.svg\" /></div>", '.deck-overlay');
        }
      }
      if (deck == 'france') {
        var _added3 = 0;
        if (!his_self.game.deck[0].discards['004']) {
          _added3++;
          his_self.app.browser.addElementToSelector("<div id=\"004\" class=\"card 004\"><img src=\"/his/img/cards/HIS-004.svg\" /></div>", '.deck-overlay');
        }
        for (var _i4 = 0; _i4 < his_self.game.state.cards_left['france'] - _added3; _i4++) {
          his_self.app.browser.addElementToSelector("<div id=\"cardback\" class=\"card cardback\"><img src=\"/his/img/cards/cardback.svg\" /></div>", '.deck-overlay');
        }
      }
      if (deck == 'hapsburg') {
        var _added4 = 0;
        if (!his_self.game.deck[0].discards['002']) {
          _added4++;
          his_self.app.browser.addElementToSelector("<div id=\"002\" class=\"card 002\"><img src=\"/his/img/cards/HIS-002.svg\" /></div>", '.deck-overlay');
        }
        for (var _i5 = 0; _i5 < his_self.game.state.cards_left['hapsburg'] - _added4; _i5++) {
          his_self.app.browser.addElementToSelector("<div id=\"cardback\" class=\"card cardback\"><img src=\"/his/img/cards/cardback.svg\" /></div>", '.deck-overlay');
        }
      }
      if (deck == 'ottoman') {
        var _added5 = 0;
        if (!his_self.game.deck[0].discards['001']) {
          _added5++;
          his_self.app.browser.addElementToSelector("<div id=\"001\" class=\"card 001\"><img src=\"/his/img/cards/HIS-001.svg\" /></div>", '.deck-overlay');
        }
        for (var _i6 = 0; _i6 < his_self.game.state.cards_left['ottoman'] - _added5; _i6++) {
          his_self.app.browser.addElementToSelector("<div id=\"cardback\" class=\"card cardback\"><img src=\"/his/img/cards/cardback.svg\" /></div>", '.deck-overlay');
        }
      }
      if (deck == 'hand') {
        for (var _i7 = 0; _i7 < his_self.game.deck[0].fhand[0].length; _i7++) {
          var cidx = his_self.game.deck[0].fhand[0][_i7];
          var cimg = his_self.returnCardImage(cidx);
          var html = "<div id=\"".concat(cidx, "\" class=\"card ").concat(cidx, "\">").concat(cimg, "</div>");
          his_self.app.browser.addElementToSelector(html, '.deck-overlay');
        }
      }
      if (deck == 'dhand') {
        if (his_self.game.deck[1]) {
          for (var _i8 = 0; _i8 < his_self.game.deck[1].hand[0].length; _i8++) {
            var _cidx = his_self.game.deck[1].hand[0][_i8];
            var _cimg = his_self.returnCardImage(_cidx);
            var _html = "<div id=\"".concat(_cidx, "\" class=\"card ").concat(_cidx, "\">").concat(_cimg, "</div>");
            his_self.app.browser.addElementToSelector(_html, '.deck-overlay');
          }
        }
      }
      if (deck == 'all') {
        for (var key in his_self.game.deck[0].cards) {
          var _cidx2 = key;
          var _cimg2 = his_self.returnCardImage(_cidx2);
          var _html2 = "<div id=\"".concat(_cidx2, "\" class=\"card ").concat(_cidx2, "\">").concat(_cimg2, "</div>");
          his_self.app.browser.addElementToSelector(_html2, '.deck-overlay');
        }
      }
      if (deck == 'diplomatic') {
        if (his_self.game.deck[1]) {
          for (var _key in his_self.game.deck[1].cards) {
            var _cidx3 = _key;
            var _cimg3 = his_self.returnCardImage(_cidx3);
            var _html3 = "<div id=\"".concat(_cidx3, "\" class=\"card ").concat(_cidx3, "\">").concat(_cimg3, "</div>");
            his_self.app.browser.addElementToSelector(_html3, '.deck-overlay');
          }
        }
      }
      if (deck == 'discards') {
        for (var _key2 in his_self.game.deck[0].discards) {
          var _cidx4 = _key2;
          var _cimg4 = his_self.returnCardImage(_cidx4);
          var _html4 = "<div id=\"".concat(_cidx4, "\" class=\"card ").concat(_cidx4, "\">").concat(_cimg4, "</div>");
          his_self.app.browser.addElementToSelector(_html4, '.deck-overlay');
        }
      }
      if (deck == 'removed') {
        for (var _i9 = 0; _i9 < his_self.game.state.removed.length; _i9++) {
          var _cidx5 = his_self.game.state.removed[_i9];
          var _cimg5 = his_self.returnCardImage(_cidx5);
          var _html5 = "<div id=\"".concat(_cidx5, "\" class=\"card ").concat(_cidx5, "\">").concat(_cimg5, "</div>");
          his_self.app.browser.addElementToSelector(_html5, '.deck-overlay');
        }
      }
      if (deck == 'unplayed') {
        for (var _key3 in his_self.game.deck[0].cards) {
          if (!his_self.game.state.removed.includes(_key3)) {
            if (!his_self.game.deck[0].discards[_key3]) {
              if (!his_self.game.deck[0].removed[_key3]) {
                var _cimg6 = his_self.returnCardImage(_key3);
                var _html6 = "<div id=\"".concat(_key3, "\" class=\"card ").concat(_key3, "\">").concat(_cimg6, "</div>");
                his_self.app.browser.addElementToSelector(_html6, '.deck-overlay');
              }
            }
          }
        }
      }
      this.pushHudUnderOverlay();
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var his_self = this.mod;
      $('.deck-overlay .card').off();
      $('.deck-overlay .card').on('mouseover', function () {
        var action2 = $(this).attr('id');
        his_self.cardbox.show(action2);
      });
      $('.deck-overlay .card').on('mouseout', function () {
        var action2 = $(this).attr('id');
        his_self.cardbox.hide(action2);
      });
    }
  }]);
}();
module.exports = DeckOverlay;